import { call, put, takeEvery } from 'redux-saga/effects';
import { replace } from 'connected-react-router';
import {
  sourceMappingSuccess,
  sourceMappingFailure,
  createSourceMappingSuccess,
  createSourceMappingFailure,
  updateSourceMappingSuccess,
  updateSourceMappingFailure,
} from './actions';
import {
  SOURCE_MAPPING_REQUEST,
  CREATE_SOURCE_MAPPING_REQUEST,
  UPDATE_SOURCE_MAPPING_REQUEST,
} from './actionTypes';
import SourceMappingService from '../../services/SourceMappingService';

export function* getSourceMappingTask(action) {
  try {
    const dealerId = action.payload;
    const sourceMapping = yield call(
      SourceMappingService.getSourceMapping,
      dealerId,
    );
    yield put(sourceMappingSuccess(sourceMapping));
  } catch (error) {
    yield put(sourceMappingFailure(error));
  }
}

export function* createSourceMappingTask(action) {
  try {
    const params = action.payload;
    const sourceMapping = yield call(
      SourceMappingService.createSourceMapping,
      params,
    );
    yield put(createSourceMappingSuccess(sourceMapping));
    yield put(replace(`/${params.dealer_id}/sourceMappings`));
  } catch (error) {
    yield put(createSourceMappingFailure(error));
  }
}

export function* updateSourceMappingTask(action) {
  try {
    const params = action.payload;
    const sourceMapping = yield call(
      SourceMappingService.updateSourceMapping,
      params,
    );
    yield put(updateSourceMappingSuccess(sourceMapping));
    yield put(replace(`/${params.dealer_id}/sourceMappings`));
  } catch (error) {
    yield put(updateSourceMappingFailure(error));
  }
}

export function* sourceMappingsSaga() {
  yield takeEvery(SOURCE_MAPPING_REQUEST, getSourceMappingTask);
  yield takeEvery(CREATE_SOURCE_MAPPING_REQUEST, createSourceMappingTask);
  yield takeEvery(UPDATE_SOURCE_MAPPING_REQUEST, updateSourceMappingTask);
}
